// Backend addresses come from the environment file Vite loaded for the mode
// it was started with (.env.dev, .env.staging, .env.production — committed,
// public values) and never from code, so one build cannot point at another
// environment's backend.
const required = (name: 'VITE_API_URL' | 'VITE_AI_API_URL'): string => {
  const value = import.meta.env[name]
  if (!value) throw new Error(`${name} is not set — start Vite with --mode <env> or add it to .env.local`)
  return value
}

export const EnvironmentVariable = {
  localEnvConfig: {
    API_URL: required('VITE_API_URL'),
    CHAT_BOT_API_URL: required('VITE_AI_API_URL'),
  },
} as const
